import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { withStyles } from "@mui/styles";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { withRouter } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { getCurrentFunctionName } from "../../performanceModeManager";
import InterventionsList from "./InterventionsList";
import {
    filtersOnlyPausedInterventionsByCustomer,
    setSelectedDisplayMode,
} from "../../redux/intervention/interventionActions";
import { arraysAreSame } from "../../lib/array_helper";

const styles = {
    appBar: {
        position: "relative",
        marginBottom: "10px",
    },
    flex: {
        flex: 1,
    },
};

class ImputationRedirectionModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedDisplayModeId: this.props.interventionsFilters.currentModeId,
        };

        let customerId = 0;
        if (this.props.currentIntervention.delivery_customer_id)
            customerId = this.props.currentIntervention.delivery_customer_id.id;

        this.props.filtersOnlyPausedInterventionsByCustomer(
            { ...this.props.interventionsFilters },
            customerId,
            this.props.currentIntervention.id
        );
    }

    componentWillUnmount() {
        //Remettre le mode d'affichage comme il était avant qu'on y touche
        this.props.setSelectedDisplayMode(this.state.selectedDisplayModeId, this.props.interventionsFilters);
    }

    shouldComponentUpdate(nextProps) {
        let filteredAndSortedInterventionsChanged = !arraysAreSame(
            this.props.interventionsFilters.filteredAndSortedInterventions,
            nextProps.interventionsFilters.filteredAndSortedInterventions,
            true
        );

        return (
            this.props.imputationRedirectionModalOpenned !== nextProps.imputationRedirectionModalOpenned ||
            this.props.interventionsFilters.currentModeId !== nextProps.interventionsFilters.currentModeId ||
            filteredAndSortedInterventionsChanged
        );
    }

    close() {
        this.props.closeModal();
    }

    goToImputations() {
        this.close();
        this.props.history.push("/activity");
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        const { classes } = this.props;

        let interventionsOfSameCustomer = this.props.interventionsFilters.filteredAndSortedInterventions;

        return (
            <Dialog
                aria-labelledby="simple-dialog-title"
                open={this.props.imputationRedirectionModalOpenned}
                onClose={this.close.bind(this)}
                fullScreen={interventionsOfSameCustomer.length > 0}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            onClick={this.close.bind(this)}
                            aria-label="Close"
                            id="close-imputation-redirection-modal"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className="without-side-padding">
                    {interventionsOfSameCustomer.length > 0 ? (
                        <div className="full_size control-margin-top">
                            <Typography
                                variant="h6"
                                color="inherit"
                                className={classes.flex + " col-lg-12 col-md-12 col-sm-12 col-12"}
                            >
                                {"Un autre OT à faire signer pour ce client?"}
                            </Typography>
                            <InterventionsList
                                interventionsFilters={this.props.interventionsFilters}
                                interventions={interventionsOfSameCustomer}
                            />
                        </div>
                    ) : (
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 full_size control-margin-top">
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {"Continuer vers la saisie des temps?"}
                            </Typography>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.goToImputations.bind(this)} variant="contained" color="secondary">
                        {interventionsOfSameCustomer.length > 0
                            ? "Non ! Continuer vers la saisie des temps !"
                            : "C'est parti !"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        imputationRedirectionModalOpenned: state.interventions.imputationRedirectionModalOpenned,
        interventionsFilters: state.interventions,
        currentIntervention: state.intervention.currentIntervention,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedDisplayMode: (value, interventionsFilters) =>
            dispatch(setSelectedDisplayMode(value, interventionsFilters)),
        filtersOnlyPausedInterventionsByCustomer: (interventionsFilters, customerId, currentInterventionId) =>
            dispatch(filtersOnlyPausedInterventionsByCustomer(interventionsFilters, customerId, currentInterventionId)),
    };
};

export default compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
)(ImputationRedirectionModal);
